/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { saveAs } from 'file-saver';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Tooltip } from 'appkit-react';

import {
    getPreviousBatchVar, isFileUploadingVar, showBatchAlertVar, showReportMenuVar,
    tenantIdVar, leftNavigationItemsVar, moduleIdVar, currentLeftMenuVar,
} from 'Apollo/config';
import {
    GET_BATCH_TESTS_FOR_FR2052A, GET_FR2052A_DOWNLOADED_RESULT, GET_LATEST_BATCH_FOR_FR2052A, GET_QUARTER_FILTERED_BATCH_TEST_FOR_FR2052A, GET_SUMMARY_QUARTER_FOR_FR2052A,
} from 'Apollo/Queries/Rules/FR2052aResults';
import { ModuleEnum } from 'constants';
import DiagnosticResultsUI from 'views/DiagnosticResults/components';
import crossReportImg from 'assets/images/cross-report-black.svg';
import StatusComponent from '../../../DiagnosticResults/components/StatusComponent';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem', color: '#464646' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const FR2052ALandingPage = () => {
    const pageName = 'FR 2052A Diagnostic Results';
    const history = useHistory();
    const location = useLocation();
    const [regulation, setRegulation] = useState(location.state.regulation);
    const isFileUploading = useReactiveVar(isFileUploadingVar);
    const showBatchAlert = useReactiveVar(showBatchAlertVar);
    const [selectedQuarter, setSelectedQuarter] = useState('');
    const [oneTimeFlag, setOneTimeFlag] = useState(true);
    const getPreviousBatch = useReactiveVar(getPreviousBatchVar);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [queryError, setQueryError] = useState(false);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo query to fetch batch tests result  */
    const [getBatchTestData, { loading: isLoading, data }] = useLazyQuery(GET_BATCH_TESTS_FOR_FR2052A, {
        variables: {
            input: {
                pageSize: 10000,
                pageNumber: 1,
                getPreviousBatch,
                tenantId,
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to fetch getCurrentStatusOfLatestBatch */
    const [getCurrentStatusOfLatestBatch, {
        data: { getCurrentStatusOfLatestBatchForFR2052A = {} } = {}, error: getCurrentStatusOfLatestBatchError, stopPolling,
    }] = useLazyQuery(GET_LATEST_BATCH_FOR_FR2052A, {
        variables: {
            input: {
                tenantId,
            },
        },
        pollInterval: 20000,
        fetchPolicy: 'no-cache',
    });

    /* Apollo query fetch batch test result selected quarter  */
    const [getQuarterFilteredData, filteredBatchTests] = useLazyQuery(GET_QUARTER_FILTERED_BATCH_TEST_FOR_FR2052A, {
        fetchPolicy: 'no-cache',
    });

    /* Apollo query fetch to quarters  */
    const [getSummaryQuarter, summaryQuartersData] = useLazyQuery(GET_SUMMARY_QUARTER_FOR_FR2052A, {
        variables: {
            input: {
                tenantId,
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to download batch test result  */
    const [getDownloadedResult, { loading: isDownloading, data: { getFR2052ASummaryDetailsForDownload = {} } = {} }] = useLazyQuery(GET_FR2052A_DOWNLOADED_RESULT, {
        fetchPolicy: 'no-cache',
    });

    const getLatestBatch = () => {
        stopPolling();
        setOneTimeFlag(true);
        getPreviousBatchVar(false);
        setShowSuccessAlert(false);
    };

    /* status component fetched from diagonstic result folder */
    const getSpanStyle = status => (
        <StatusComponent
            status={status}
        />
    );

    /* Column configuration for batch test summary table */
    const columns = [
        {
            Header: 'Rule ID',
            accessor: 'ruleId',
            minWidth: 70,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Flow Type',
            accessor: 'flowType',
            minWidth: 130,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Product ID',
            accessor: 'productId',
            minWidth: 80,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Product',
            accessor: 'product',
            minWidth: 150,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Field Name',
            accessor: 'fieldName',
            minWidth: 130,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Associated rule',
            accessor: 'editTest',
            minWidth: 290,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Enabled Y/N',
            accessor: 'isActive',
            minWidth: 110,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { isActive } } = row;
                return isActive === 'Y' ? <span style={{ paddingLeft: '40%' }}>Y</span> : <span style={{ paddingLeft: '40%' }}>N</span>;
            },
        },
        {
            Header: 'Rule applicable',
            accessor: 'isRuleApplicable',
            minWidth: 117,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { isRuleApplicable } } = row;
                return isRuleApplicable === 'N' ? (
                    <Tooltip content={<span className="a-h6">Applicability dependent on Low tier or High tier categorization</span>} placement="top" tooltipTheme="light">
                        {isRuleApplicable}
                    </Tooltip>
                )
                    : (
                        <span>{isRuleApplicable}</span>
                    );
            },
        },
        {
            Header: 'Test status',
            accessor: 'testRunStatus',
            minWidth: 90,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { isRuleApplicable, testRunStatus } } = row;
                return isRuleApplicable === 'N' ? (
                    <span
                        className="appkiticon
                        icon-alert-outline"
                        style={{ color: '#FFB600', fontSize: '1.3rem', marginLeft: '1rem' }}
                    />
                ) : getSpanStyle(testRunStatus);
            },
        },
    ];

    /* Breadcrumb items configuration */
    const breadcrumbItems = [
        {
            link: '',
            value: (
                <span
                    className="appkiticon icon-home-fill font-16"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.push('/');
                            leftNavigationItemsVar([]);
                            moduleIdVar(null);
                        }
                    }
                    role="presentation"
                />
            ),
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">FR 2052A Diagnostic Results</span>,
        },
    ];

    /* Method for sidebar navigation */
    const onNavigate = () => {
        // method to handle sidebar navigation
    };

    /* Navigates to upload report page */
    const uploadReport = () => {
        history.push(
            {
                pathname: '/UploadReport',
            },
        );
    };

    /* Calls the  getDownloadedResult */
    const downloadResult = () => {
        const quarter = Math.floor(selectedQuarter.getMonth() / 3 + 1);
        const year = selectedQuarter.getFullYear();
        const qtrValue = `q${quarter}_${year}`;
        getDownloadedResult({
            variables: {
                input: {
                    tenantId,
                    period: qtrValue,
                },
            },
        });
    };

    /* Navigates to result page of specific rule */
    const onNavigateToResult = row => {
        history.push(
            {
                pathname: '/FR2052aResult',
                state: {
                    batchId: row.batchId,
                    ruleId: row.ruleId,
                    period: row.period,
                },
            },
        );
    };

    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.RULEENGINE);
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setRegulation(location.state.regulation);
        showReportMenuVar(true);
    }, [location]);

    /* Side effect when getPreviousBatch changed */
    useEffect(async () => {
        getBatchTestData();
        getSummaryQuarter();
        if (getPreviousBatch === true) {
            getCurrentStatusOfLatestBatch();
        }
    }, [getPreviousBatch]);

    /* Side effect when getBatchTestsForFR2052A changed */
    useEffect(() => {
        if (data && data.getBatchTestsForFR2052A) {
            const qtrValue = data.getBatchTestsForFR2052A[0].period;
            const quarter = qtrValue.split('_')[0];
            const year = qtrValue.split('_')[1];
            let date;
            switch (quarter) {
                case 'q1':
                    date = new Date(year, 0, 1);
                    break;
                case 'q2':
                    date = new Date(year, 3, 1);
                    break;
                case 'q3':
                    date = new Date(year, 6, 1);
                    break;
                case 'q4':
                    date = new Date(year, 9, 1);
                    break;
                default:
                    break;
            }
            setSelectedQuarter(date);
        } else {
            setSelectedQuarter('');
        }
    }, [data]);

    /* Side effect when getCurrentStatusOfLatestBatchForFR2052A changed */
    useEffect(() => {
        const isCurrentStatusForLatestBatchAvailable = getCurrentStatusOfLatestBatchForFR2052A.length > 0 && Object.keys(getCurrentStatusOfLatestBatchForFR2052A[0]).length > 0;

        if (isCurrentStatusForLatestBatchAvailable && (
            (getCurrentStatusOfLatestBatchForFR2052A[0]).batchRunStatus === 'Completed'
                || (getCurrentStatusOfLatestBatchForFR2052A[0]).batchRunStatus === 'Failed')) {
            showBatchAlertVar(false);
            stopPolling();
        }
        if (isCurrentStatusForLatestBatchAvailable && (getCurrentStatusOfLatestBatchForFR2052A[0]).batchRunStatus === 'Completed') {
            setShowSuccessAlert(true);
        }
    }, [getCurrentStatusOfLatestBatchForFR2052A, stopPolling]);

    /* Side effect when getCurrentStatusOfLatestBatchError changed */
    useEffect(() => {
        if (getCurrentStatusOfLatestBatchError) {
            stopPolling();
            setQueryError(true);
            showBatchAlertVar(false);
        }
    }, [getCurrentStatusOfLatestBatchError, stopPolling]);

    /* Side effect when selectedQuarter changed */
    useEffect(() => {
        if (selectedQuarter !== '' && !getPreviousBatch) {
            const quarter = Math.floor(selectedQuarter.getMonth() / 3 + 1);
            const year = selectedQuarter.getFullYear();
            const qtrValue = `q${quarter}_${year}`;
            getQuarterFilteredData({
                variables: {
                    input: {
                        period: qtrValue,
                        tenantId,
                        pageNumber: 1,
                        pageSize: 500,
                    },
                },
            });
            setOneTimeFlag(false);
        }
    }, [selectedQuarter, getPreviousBatch]);

    /* Side effect when getFR2052ASummaryDetailsForDownload changed */
    useEffect(() => {
        if (getFR2052ASummaryDetailsForDownload && getFR2052ASummaryDetailsForDownload.length > 0) {
            const json = getFR2052ASummaryDetailsForDownload;
            const fields = Object.keys(json[0]);
            const replacer = (key, value) => (value === null ? '' : value);
            let csv = json.map(row => fields.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
            csv.unshift(fields.join(','));
            csv = csv.join('\r\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            saveAs(blob, `${regulation}_result.csv`);
        }
    }, [getFR2052ASummaryDetailsForDownload]);

    return (
        <DiagnosticResultsUI
            pageName={pageName}
            columns={columns}
            summaryQuartersData={summaryQuartersData}
            selectedQuarter={selectedQuarter}
            setSelectedQuarter={setSelectedQuarter}
            commonData={oneTimeFlag ? data && data.getBatchTestsForFR2052A : filteredBatchTests.data && filteredBatchTests.data.getFR2052ABatchTestsByQuarter}
            breadcrumbItems={breadcrumbItems}
            onNavigate={onNavigate}
            uploadReport={uploadReport}
            downloadResult={downloadResult}
            isDownloading={isDownloading}
            onNavigateToResult={onNavigateToResult}
            isBatchTestDataLoading={isLoading}
            isFileUploading={isFileUploading}
            latestBatch={getCurrentStatusOfLatestBatchForFR2052A}
            getPreviousBatch={getPreviousBatch}
            showSuccessAlert={showSuccessAlert}
            getLatestBatch={getLatestBatch}
            showBatchAlert={showBatchAlert}
            queryError={queryError}
        />
    );
};

export default FR2052ALandingPage;
